import { normalizeNetworkId } from "../AmendTariffs/types";
import { formatDealSummary, formatDealSummaryFromObject, getCustomerEmail, getCustomerName, getDealId, getParameters, mapStatus, parseDealDate, } from "./chosenPackageHelpers";
export { formatDealDate } from "./chosenPackageHelpers";
const isListPackage = (raw) => typeof raw.network === "string" ||
    (raw.dealSummary !== undefined && typeof raw.dealSummary === "object");
export const mapChosenPackageToWonDeal = (raw) => {
    if (isListPackage(raw)) {
        const networkId = normalizeNetworkId(String(raw.network ?? ""));
        const id = getDealId(raw);
        if (!networkId || !id) {
            return null;
        }
        const dealSummary = raw.dealSummary && typeof raw.dealSummary === "object"
            ? formatDealSummaryFromObject(raw.dealSummary)
            : formatDealSummary(raw);
        return {
            id,
            date: parseDealDate(raw),
            customerName: getCustomerName(raw),
            customerEmail: getCustomerEmail(raw),
            dealSummary,
            networkId,
            status: mapStatus(raw.status ?? raw.dealStatus),
        };
    }
    const parameters = getParameters(raw);
    const networkId = normalizeNetworkId(String(parameters?.platform ?? ""));
    const id = getDealId(raw);
    if (!networkId || !id) {
        return null;
    }
    return {
        id,
        date: parseDealDate(raw),
        customerName: getCustomerName(raw),
        customerEmail: getCustomerEmail(raw),
        dealSummary: formatDealSummary(raw),
        networkId,
        status: mapStatus(raw.status ?? raw.dealStatus),
    };
};
export const mapChosenPackagesToWonDeals = (packages) => packages
    .map((package_) => mapChosenPackageToWonDeal(package_))
    .filter((deal) => deal !== null);
